import React from 'react';

export default function withCopyToClipboard(WrappedComponent, tooltipAttribute){
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleOnCLick = this.handleOnCLick.bind(this);
        }

        handleOnCLick(e) {
            const target = e.target.hasAttribute('data-copy-text')
                ? e.target
                : e.target.parentElement;

            if (!target) return;

            const temp = document.createElement('input');
            target.insertBefore(temp, target.firstChild);
            temp.value = target.getAttribute('data-copy-text');
            temp.select();
            document.execCommand('copy');
            temp.remove();

            target.setAttribute(tooltipAttribute, 'Copied to clipboard');

            if (this.props.copyCallback instanceof Function) {
                this.props.copyCallback(e);
            }
        };

        onMouseLeave(e) {
            const target = e.target.hasAttribute(tooltipAttribute)
                ? e.target
                : e.target.parentElement;
            target.removeAttribute(tooltipAttribute);
        }

        render() {
            const props = Object.assign({}, this.props);
            delete props.copyCallback;
            return <WrappedComponent onClick={this.handleOnCLick} onMouseLeave={this.onMouseLeave} {...props} />
        }
    }
}
